import React from 'react';
import classes from './RoundButton.module.scss';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { SquareButtonIconsEnum } from '../../../constants/square-button-icons';
import classNames from 'classnames';
import { Void } from '../../../models/basic-objects';
import { SquareButtonIcon } from '../../images/Icon/SquareButtonIcon';

export type RoundButtonViewProps = {
  size: 'large';
  color: ButtonColorsEnum;
  icon: SquareButtonIconsEnum.edit | SquareButtonIconsEnum.notification;
  action?: Void;
  active?: boolean;
  disabled?: boolean;
  loading?: boolean;
};

export const RoundButtonView = (props: RoundButtonViewProps): JSX.Element => {
  const roundButtonClasses = classNames(
    classes.RoundButton,
    classes[`RoundButton${props.size}`],
    classes[`RoundButton${props.color}`],
    classes[`RoundButton${props.icon}`],
    {
      [classes[`RoundButton${props.color}`]]: true,
      [classes.Loading]: !!props.loading,
      [classes.Active]: !!props.active,
      [classes.Disabled]: props.disabled
    }
  );

  return (
    <a onClick={props.action} className={roundButtonClasses}>
      <SquareButtonIcon name={SquareButtonIconsEnum.edit} />
    </a>
  );
};
